<template>
  <audio
    ref="audioElement"
    v-bind="attrs"
    :class="[bem.b()]"
    :src="src"
    :autoplay="autoplay"
    :loop="loop"
    :preload="preload"
    :muted="muted"
    :controls="controls"
  >
    <source :src="src" :type="getType(format)" />
    您的浏览器不支持音频播放。
  </audio>
</template>

<script setup lang="ts">
import { createNamespace } from '@ll-plus/utils'
import { ref, useAttrs } from 'vue'
import { audioPlayerProps } from './audio-player'

defineOptions({ name: 'LlAudioPlayer' })

const attrs = useAttrs()
const bem = createNamespace('audio-player')

defineProps(audioPlayerProps)

// 响应式数据
const audioElement = ref()

const audioTypeMap = {
  MP3: 'audio/mpeg',
  OGG: 'audio/ogg',
  AAC: 'audio/aac',
  WAV: 'audio/wav',
  WMA: 'audio/x-ms-wma',
  WEBM: 'audio/webm',
  FLAC: 'audio/flac',
  ALAC: 'audio/alac',
  AMR: 'audio/amr',
  MIDI: 'audio/midi',
}

const getType = (format: string) => {
  return audioTypeMap[format.toUpperCase()] || 'audio/mpeg'
}
</script>
